import React, { useState, useEffect } from "react";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import Approved from "../../../assets/Icon/approved.png";
import PromoFile from "./PromoFile";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
const ApprovedPromoVideo = () => {
  const [buffer, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [count, setApproved] = useState("");

  const ApprovedVideos = (props) => {
    axios.get(`/api/star/promoVideoApproved`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
        setApproved(res.data.approveTotal);
      }

      setLoading(false);
    });
  };

  useEffect(() => {
    ApprovedVideos();
  }, []);

  return (
    <>
      <AllDataHeader
        title={"Approved Promo Video"}
        image={Approved}
        count={count}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <PromoFile
          data={event}
          text={"edit"}
          urlLink={`/superstar/edit/promoVideo`}
        />
      )}
    </>
  );
};

export default ApprovedPromoVideo;
